import React from 'react';
import ReactDOM from 'react-dom';
import DoNotSellForm from './DoNotSellForm';
import { mergeStyles } from '@fluentui/react';


// Inject some global styles
mergeStyles({
  ':global(body,html,#root)': {
    margin: 0,
    padding: 0,
    height: '100vh',
  },
});

ReactDOM.render(<DoNotSellForm />, document.getElementById('root'));
